import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NgStorage } from '@core/enums/ngStorage/ngStorage.enum';
import { AuthService } from '@core/service/auth/auth.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const _authService = inject(AuthService);
  const _router = inject(Router);

  const existToken = await _authService.hasStorage(NgStorage.TOKEN);

  if (!existToken) {
    if (state?.url) {
      await _authService.setStorage(NgStorage.REDIRECT_URL, state.url);
    }
    _router.navigate(['/login']);
    return false;
  }
  return true;
};
